import { useAuthContext } from './useAuthContext';

// Reactive userId from the app-wide AuthProvider. Avoid per-consumer getUser() calls.
export function useAuthUser() {
  const { user } = useAuthContext();
  return user?.id ?? null;
}
